// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const cufant: PokeData = {
  "id": 878,
  "name": "cufant",
  "height": 12,
  "weight": 1000,
  "base_experience": 66,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "growl",
    "strength",
    "dig",
    "rollout",
    "rock-smash",
    "superpower",
    "iron-defense",
    "iron-head",
    "bulldoze",
    "play-rough",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "growl",
    "rock-smash",
    "superpower",
    "play-rough",
    "magnet-pull",
    "iron-defense",
    "steel-beam",
    "metal-sound",
    "smart-strike",
    "metal-rush",
    "metal-claw"
  ],
  "evolution_chain": {
    "id": 460,
    "item": null,
    "species": [
      {
        "name": "cufant",
        "order": 878,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "copperajah",
        "order": 879,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 878,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60.5,
    "speed": 40,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
